import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCoinMode } from '@ui/hooks/useCoinMode';
import { useVenoSDK } from '@ui/providers/VenoSDKProvider';
import { QueryKey } from '@ui/queries/queryKey';
import { getPidType } from '@ui/utils/garden';
import type { EthersError } from '@veno-app/sdk';

import {
  STEP,
  useGardenNftDrawerStore,
} from '../GardenNftDrawersShared/useGardenNftDrawer';
import { useGrowHelpers } from '../GrowHelpersProvider';

const useDoUnstakeNfts = () => {
  const coinMode = useCoinMode();
  const queryClient = useQueryClient();
  const sdk = useVenoSDK();
  const { gardenType } = useGrowHelpers();
  const selectedTokens = useGardenNftDrawerStore((s) => s.selectedTokens);
  const setStep = useGardenNftDrawerStore((s) => s.setStep);

  return useMutation(
    async () => {
      const stakeRet = await sdk.VenoStorm.unstakeNft(
        getPidType(coinMode, gardenType),
        selectedTokens.map(({ collection }) => collection),
        selectedTokens.map(({ id }) => parseInt(id)),
      );
      await stakeRet.txReceiptPromise;
    },
    {
      onSuccess: async () => {
        queryClient.invalidateQueries([QueryKey.BOOST_MULTIPLIERS_NFTS]);
        queryClient.invalidateQueries([QueryKey.OWNED_NFTS]);
        queryClient.invalidateQueries([QueryKey.STAKED_NFTS]);
        setStep(STEP.success);
      },
      onError: async (err) => {
        useGardenNftDrawerStore.setState({
          error: err as EthersError,
        });
        setStep(STEP.failed);
      },
    },
  );
};

export default useDoUnstakeNfts;
